import { Immutable } from 'immer'
import { queryClient } from '../../../api/query-client'
import { mergeKeyWith } from '../../../common/query'
import { IKvitteringData } from '../../../ducks/kvittering/types'
import { kvitteringKeys } from '../../kvitteringer/queries/helpers'

export { arkiveringStatusKeys, arkiveringStatusHelpers }

const getArkiveringStatusKeys = () => {
  const keys = {
    all: [{ entity: 'arkivering-status' }] as const,
    get: (kvitteringId: string) => mergeKeyWith(keys.all, { kvitteringId }),
  }

  return keys
}

const arkiveringStatusKeys = getArkiveringStatusKeys()

export type ArkiveringStatusKeys = typeof arkiveringStatusKeys

const arkiveringStatusHelpers = {
  getArkiveringStatusVars: (kvitteringId: string) => {
    const kvittering = queryClient.getQueryData<Immutable<IKvitteringData>>(
      kvitteringKeys.kvitteringId(kvitteringId)
    )

    return {
      noarksakAar: kvittering?.noarksakAar ?? '',
      noarksakSekvensnummer: kvittering?.noarksakSekvensnummer ?? '',
      hoveddokumentId: kvittering?.hoveddokumentId ?? '',
    }
  },
}
